import { render, staticRenderFns } from "./MetaLinks.vue?vue&type=template&id=f4039cd6&scoped=true"
import script from "./MetaLinks.vue?vue&type=script&lang=js"
export * from "./MetaLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4039cd6",
  null
  
)

export default component.exports